module.exports = __webpack_public_path__ + "static/media/KHOF05.686ed302.jpg";